import VanityNumbersSearch from "./vanity-numbers-search.svelte";

const root = document.querySelector("#app-vanity-numbers-search");

if (root) {
  const options = root.getAttribute("data-options");
  const title = root.getAttribute("data-title");

  let parsedOptions = [];
  try {
    parsedOptions = options
      ? [].concat(JSON.parse(options))
      : ["local", "toll-free"];
    console.log("Parsed options:", parsedOptions);
  } catch (error) {
    parsedOptions = ["local", "toll-free"];
    console.error("Error parsing options:", error);
  }

  const attributes = {
    theme: root.getAttribute("data-theme") || "default",
    preselectedAreaCode: root.getAttribute("data-area-code") || "",
    title: title || "Search for a Vanity Number",
    options: parsedOptions,
  };

  const target = root.attachShadow({ mode: "open" });
  new VanityNumbersSearch({
    target,
    props: {
      ...attributes,
      theme: attributes.theme as "default" | "phone-numbers",
    },
  });
} else {
  console.error("Demo container not found.");
}
